import React, { useState } from 'react';
import { Helmet } from 'react-helmet';

export default function FAQAccordion({ title, items }) {
  const [openIndex, setOpenIndex] = useState(null);

  const faqSchema = items && items.length > 0 ? {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map(item => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: { '@type': 'Answer', text: item.a },
    })),
  } : null;

  return (
    <>
      {faqSchema && (
        <Helmet>
          <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
        </Helmet>
      )}
      <div className="xfaq-section">
        <h2 className="xfaq-title">{title}</h2>
        <div className="xfaq-list">
          {items.map((item, i) => (
            <div key={i} className={'xfaq-item' + (openIndex === i ? ' xfaq-item--open' : '')}>
              <h3
                className="xfaq-question"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span>{item.q}</span>
                <span className="xfaq-icon">{openIndex === i ? '−' : '+'}</span>
              </h3>
              {openIndex === i && (
                <div className="xfaq-answer">
                  <p>{item.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
